import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { SharedThirdPartyModule } from '@homeleite/shared-third-party';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [LoginComponent],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedThirdPartyModule
    ],
    exports: [LoginComponent]
})
export class LoginModule { }
